import AddToBlackList from './AddToBlackList';

export default AddToBlackList;
